import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=4a0c2445&scoped=true&"
import script from "./NotificationView.vue?vue&type=script&lang=js&"
export * from "./NotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c2445",
  null
  
)

export default component.exports